export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    'hy_AM': 'Armenian (Armenia)',
    "WIN_DRAW_WIN": "1X2",
    "CORRECT_SCORE": "Score exact",
    "TOTAL_GOALS": "Nombre exact de buts",
    "DOUBLE_CHANCE": "Double chance",
    "UNDER_OVER": "Plus/Moins",
    "UNDER_OVER_25": "Plus/Moins",
    "UNDER_OVER_25_INITIALS": "+/- 2.5",
    "UNDER_OVER_35_INITIALS": "+/- 3.5",
    "UNDER_OVER_15": "Plus/Moins 1.5",
    "ASIAN_HANDICAP": "Handicap asiatique",
    "HANDICAP": "1X2 Handicap",
    "HANDICAP_FIRST": "1X2 Handicap domicile +1",
    "HANDICAP_SECOND": "1X2 Handicap extérieur +1",
    "UNDER_OVER_05": "Moins/Plus 0.5",
    "UNDER_OVER_35": "Plus/Moins 3.5",
    "BOTH_TEAMS_SCORE": "Les deux équipes marquent",
    "BOTH_TEAMS_SCORE_INITIALS": "BTTS",
    "HOME_TEAM_GOALS": "Buts de l'équipe {0}",
    "AWAY_TEAM_GOALS": "Buts de l'équipe {1}",
    "MATCH_BETTING_BOTH_TEAMS_SCORE": "Résultat & les 2 équipes marquent",
    "WINNING_MARGIN": "Marge du vainqueur",
    "CORRECT_SCORE_GROUP": "Score exact (groupé)",
    "HOME_TEAM_TO_SCORE": "{0} marque",
    "AWAY_TEAM_TO_SCORE": "{1} marque",
    "FIRST_TEAM_TO_SCORE": "1ère équipe à marquer",
    "LAST_TEAM_TO_SCORE": "Dernière équipe à marquer",
    "HALF_TIME_FULL_TIME": "Mi-temps / Temps complet",
    "TEAM_SCORECAST": "Score de l'équipe",
    "HALF_TIME_CORRECT_SCORE": "Score exact (mi-temps)",
    "HALF_TIME_RESULT": "Résultat (mi-temps)",
    "FIRST_LAST_TO_SCORE": "1ère/dernière à marquer",
    "LAST": "Dernière",
    "FIRST": "1e",
    "IN": "à",
    "LAST_THREE_GAMES": "Last 3 Games",
    "PREVIOUS": "Précédent",
    "EIGHT_RESULTS": "8 matches",
    "EIGHT_GAMES": "8 parties",
    "OVER_25": "Plus 2.5",
    "UNDER_25": "Moins 2.5",
    "OVER_35": "Plus 3.5",
    "UNDER_35": "Moins 3.5",
    "COVERED": "Couvert",
    "DID_NOT_COVER": "Non couvert",
    "SPREAD": "Handicap",
    "TOTAL_POINTS_UNDER_OVER": "Nombre de points -/+",
    "TOTAL_POINTS_OVER_UNDER": "Nombre de points +/-",
    "MONEYLINE": "Vainqueur",
    "TOTAL_POINTS_GROUP": "Total de points (5 pts)",
    "MONEY_LINE_TOTAL_POINTS": "Vainqueur & Total de points +/-",
    "SPREAD_TOTAL_POINTS": "Handicap & Total de points +/-",
    "Argentina": "Argentina",
    "Belgium": "Belgium",
    "Brazil": "Brazil",
    "Colombia": "Colombia",
    "Costa Rica": "Costa Rica",
    "Croatia": "Croatia",
    "Czech Republic": "Czech Republic",
    "Denmark": "Denmark",
    "Egypt": "Egypt",
    "England": "England",
    "France": "France",
    "Germany": "Germany",
    "Greece": "Greece",
    "Holland": "Holland",
    "Iceland": "Iceland",
    "Italy": "Italy",
    "Mexico": "Mexico",
    "Poland": "Poland",
    "Portugal": "Portugal",
    "Republic of Ireland": "Republic of Ireland",
    "Russia": "Russia",
    "Spain": "Spain",
    "Sweden": "Sweden",
    "Switzerland": "Switzerland",
    "Ukraine": "Ukraine",
    "Uruguay": "Uruguay",
    "Boston": "Boston",
    "Cleveland": "Cleveland",
    "Houston": "Houston",
    "Los Angeles": "Los Angeles",
    "Orlando": "Orlando",
    "Portland": "Portland",
    "San Antonio": "San Antonio",
    "Euro Arena": "Euro Arena",
    "Athens": "Athens",
    "Real": "Real",
    "Piraeus": "Piraeus",
    "Istanbul Blues": "Istanbul Blues",
    "Fener": "Fener",
    "Vitoria": "Vitoria",
    "Tel Aviv Yellows": "Tel Aviv Yellows",
    "Moscow": "Moscow",
    "Kaunas": "Kaunas",
    "Barcelona City": "Barcelona City",
    "Belgrade": "Belgrade",
    "Lyon": "Lyon",
    "Khimki": "Khimki",
    "Berlin": "Berlin",
    "St Petersburg": "St Petersburg",
    "Valencia": "Valencia",
    "Turkey": "Turkey",
    "Netherlands": "Netherlands",
    "Utd": "United",
    "City": "City",
    "Liverpool": "Liverpool",
    "Barcelona": "Barcelona",
    "Madrid": "Madrid",
    "Munich": "Munich",
    "Turin": "Turin",
    "Milan": "Milan",
    "Amsterdam": "Amsterdam",
    "Paris": "Paris",
    "Pittsburgh": "Pittsburgh",
    "Philadelphia": "Philadelphia",
    "Denver": "Denver",
    "New York": "New York",
    "New England": "New England",
    "Green Bay": "Green Bay",
    "San Francisco": "San Francisco",
    "Miami": "Miami",
    "Dallas": "Dallas",
    "Oakland": "Oakland",
    "Chicago": "Chicago",
    "DRAW": "Égalité",
    "HD": "{0}/Égalité",
    "DA": "Égalité/{1}",
    "HA": "{0}/{1}",
    "Under 2.5": "Moins 2.5",
    "Over 2.5": "Plus 2.5",
    "Under 1.5": "Moins 1.5",
    "Over 1.5": "Plus 1.5",
    "Under": "Moins {0}",
    "Over": "Plus {0}",
    "HOME": "{0}",
    "AWAY": "{1}",
    "Under 0.5": "Moins 0.5",
    "Over 0.5": "Plus 0.5",
    "Under 3.5": "Moins 3.5",
    "Over 3.5": "Plus 3.5",
    "Both Score Yes": "Oui",
    "Both Score No": "Non",
    "Home Not to Score": "{0} ne marque pas",
    "Home Exactly 1": "{0} marque un but",
    "Home Exactly 2": "{0} Exactly 2",
    "Home Exactly 3": "{0} Exactly 3",
    "Home Exactly 4": "{0} Exactly 4",
    "Away Not to Score": "{1} ne marque pas",
    "Away Exactly 1": "{1} marque un but",
    "Away Exactly 2": "{1} Exactly 2",
    "Away Exactly 3": "{1} Exactly 3",
    "Away Exactly 4": "{1} Exactly 4",
    "Home to Win and both teams to score": "{0} gagne et les deux équipes marquent",
    "Home to Win to nil": "{0} gagne sans prendre de but",
    "Score draw": "Score à égalité",
    "0-0": "0-0",
    "0-1": "0-1",
    "0-2": "0-2",
    "0-3": "0-3",
    "0-4": "0-4",
    "0-5": "0-5",
    "0-6": "0-6",
    "1-0": "1-0",
    "2-0": "2-0",
    "3-0": "3-0",
    "4-0": "4-0",
    "5-0": "5-0",
    "6-0": "6-0",
    "1-1": "1-1",
    "2-2": "2-2",
    "3-3": "3-3",
    "2-1": "2-1",
    "1-2": "1-2",
    "3-1": "3-1",
    "1-3": "1-3",
    "3-2": "3-2",
    "2-3": "2-3",
    "4-1": "4-1",
    "1-4": "1-4",
    "4-2": "4-2",
    "2-4": "2-4",
    "5-1": "5-1",
    "1-5": "1-5",
    "1-0,2-0,2-1": "1-0,2-0,2-1",
    "3-0,3-1,4-0": "3-0,3-1,4-0",
    "1-1,2-2": "1-1,2-2",
    "0-1,0-2,1-2": "0-1,0-2,1-2",
    "0-3,1-3,0-4": "0-3,1-3,0-4",
    "Away to Win and both teams to score": "{1} to Win and both teams to score",
    "Away to Win to nil": "{1} to Win to nil",
    "Home Win By Exactly 1 Goal": "{0} en vainqueur avec 1 but",
    "Home Win By Exactly 2 Goals": "{0} en vainqueur avec 2 buts",
    "Home Win By 3 or more goals": "{0} en vainqueur avec 3 buts",
    "Away Win By Exactly 1 Goal": "{1} en vainqueur avec 1 but",
    "Away Win By Exactly 2 Goals": "{1} en vainqueur avec 2 buts",
    "Away Win By 3 or more goals": "{1} en vainqueur avec 3 buts",
    "Draw With No Goals": "Égalité sans aucun but",
    "Draw With Goals": "Égalité avec buts",
    "Any Other": "Autre",
    "Home Not To Score": "{0} ne marque pas",
    "Home To Score": "{0} marque",
    "Away Not To Score": "{1} ne marque pas",
    "Away To Score": "{1} marque",
    "Home": "{0}",
    "No Goal": "Pas de but",
    "Away": "{1}",
    "Home/Home": "{0}/{0}",
    "Home/Draw": "{0}/Égalité",
    "Home/Away": "{0}/{1}",
    "Draw/Home": "Égalité/{0}",
    "Draw/Draw": "Égalité/Égalité",
    "Draw/Away": "Égalité/{1}",
    "Away/Home": "{1}/{0}",
    "Away/Draw": "{1}/Égalité",
    "Away/Away": "{1}/{1}",
    "Home and 1-0": "{0} et 1-0",
    "Home and 2-0": "{0} et 2-0",
    "Home and 2-1": "{0} et 2-1",
    "Away and 2-1": "{1} et 2-1",
    "Home and 3-0": "{0} et 3-0",
    "Home and 3-1": "{0} et 3-1",
    "Away and 3-1": "{1} et 3-1",
    "Home and 4-0": "{0} et 4-0",
    "Home and 1-1": "{0} et 1-1",
    "Away and 1-1": "{1} et 1-1",
    "Home and 2-2": "{0} et 2-2",
    "Away and 2-2": "{1} et 2-2",
    "Away and 0-1": "{1} et 0-1",
    "Away and 0-2": "{1} et 0-2",
    "Away and 1-2": "{1} et 1-2",
    "Home and 1-2": "{0} et 1-2",
    "Away and 0-3": "{1} et 0-3",
    "Away and 1-3": "{1} et 1-3",
    "Home and 1-3": "{0} et 1-3",
    "Away and 0-4": "{1} et 0-4",
    "Other": "Autre",
    "Draw": "Égalité",
    "120-124": "120-124",
    "125-129": "125-129",
    "130-134": "130-134",
    "135-139": "135-139",
    "140-144": "140-144",
    "145-149": "145-149",
    "150-154": "150-154",
    "155-159": "155-159",
    "160-164": "160-164",
    "165-169": "165-169",
    "170-174": "170-174",
    "175-179": "175-179",
    "Under 180": "Moins de 180",
    "180-184": "180-184",
    "185-189": "185-189",
    "190-194": "190-194",
    "195-199": "195-199",
    "200-204": "200-204",
    "205-209": "205-209",
    "210-214": "210-214",
    "215-219": "215-219",
    "220-224": "220-224",
    "225-229": "225-229",
    "230-234": "230-234",
    "235-239": "235-239",
    "240-244": "240-244",
    "245-249": "245-249",
    "Over 249": "Plus de 249",
    "26-30": "26-30",
    "31-35": "31-35",
    "36-40": "36-40",
    "41-45": "41-45",
    "46-50": "46-50",
    "25 And Under": "Moins 26",
    "25 And Under Short": "Moins 26",
    "51 And Over": "Plus 50",
    "51 And Over Short": "Plus 50",
    "and": "&",
    "slash": "/",
    "FIRST_PLAY": "1st Play",
    "SECOND_PLAY": "2nd Play",
    "THIRD_PLAY": "3rd Play",
    "FOURTH_PLAY": "4th Play",
    "FIFTH_PLAY": "5th or More Play",
    "FIELD_GOAL": "Field Goal",
    "PassTD on 1st Play": "PassTD on 1st Play",
    "PassTD on 2nd Play": "PassTD on 2nd Play",
    "PassTD on 3rd Play": "PassTD on 3rd Play",
    "PassTD on 4th Play": "PassTD on 4th Play",
    "PassTD on or after 5th Play": "PassTD on or after 5th Play",
    "RunTD on 1st Play": "RunTD on 1st Play",
    "RunTD on 2nd Play": "RunTD on 2nd Play",
    "RunTD on 3rd Play": "RunTD on 3rd Play",
    "RunTD on 4th Play": "RunTD on 4th Play",
    "RunTD on or after 5th Play": "RunTD on or after 5th Play",
    "Turnover on 1st Play": "Turnover on 1st Play",
    "Turnover on 2nd Play": "Turnover on 2nd Play",
    "Turnover on 3rd Play": "Turnover on 3rd Play",
    "Turnover on 4th Play": "Turnover on 4th Play",
    "Turnover on or after 5th Play": "Turnover on or after 5th Play",
    "Field Goal": "Field Goal",
    "US_Football_Football": "Football américain",
    "Matchday": "Journée",
    "Basketball": "Basketball",
    "Cycling": "Cycling",
    "Horses Jumps": "Horses Jumps",
    "Horses Flats": "Horses Flats",
    "Horses Sprints": "Horses Sprints",
    "Horses Furlong": "Horses Furlong",
    "Horses Trotting": "Horses Trotting",
    "Dogs": "Chiens",
    "Greyhounds": "Lévriers",
    "Rush Dogs": "Greyhounds",
    "Motor Racing": "Courses de moto",
    "Speedway": "Greyhounds",
    "Results": "Résultats",
    "Horses": "Courses hippiques",
    "Motorcycles": "Motorcycles",
    "Cars": "Voitures automobiles",
    "First Down": "1st Down",
    "Formula Racing": "Courses de moto",
    "Soccer_Euro": "Euro",
    "Soccer_Soccer3_Super_League": "Super ligue",
    "Soccer_Soccer3_Greek_League": "Greek ligue",
    "Soccer_Super_League": "Super ligue",
    "Soccer_World_Cup": "Coupe du monde",
    "Soccer_Soccer3_World_Cup": "Coupe du monde",
    "Soccer": "Football",
    "US Football": "Football américain",
    "Marble_Racing_Marbles": "Billes",
    "Marble_Racing_Marbles2": "Sable",
    "Marble_Racing_Marbles_Euro": "Soccer",
    "Marble_Racing_Marbles_Halloween": "Halloween",
    "Basketball_US1": "États-Unis",
    "Basketball_US2": "États-Unis2",
    "Basketball_Europe": "Euro",
    "Horses_Sprints": "Galop",
    "Horses_Flats": "Plat",
    "Horses_Jumps": "Obstacle",
    "Dogs_Flats": "Plat",
    "Dogs_City": "Static Odds",
    "Motor_Racing_Stock_Cars": "Voiture de série",
    "Motor_Racing_Indy_Cars": "Voiture monoplace",
    "US_Football_NFLA": "NFLA",
    "US_Football_NFL": "NFL",
    "FORECAST": "Couplé ordre",
    "TRICAST": "Trio ordre",
    "REVERSE_FORECAST": "Couplé gagnant",
    "REVERSE_TRICAST": "Trio classique",
    "FIRST_ST": "1",
    "SECOND_ND": "2",
    "THIRD_RD": "3",
    "RD": "e",
    "ST": "er",
    "ND": "e",
    "ANY": "Tout",
    "TO_WIN": "Simple gagnant",
    "RACE_CARD": "RACECARD",
    "EACH_WAY": "Gagnant placé",
    "EW": "G/P",
    "FORECAST_TRICAST": "Couplé ordre/Trio ordre",
    "EACH_WAY_ODDS_PLACE": "G/P {0} 1-2",
    "EACH_WAY_ODDS_SHOW": "G/P {0} 1-2-3",
    "EXPAND_ALL": "Expand Markets",
    "COLLAPSE_ALL": "Collapse Markets",
    "NUMBER": "Numéro",
    "SORT_BY": "Trier par",
    "BET_SLIP": "Coupon de pari",
    "CLOSE_BET_SLIP": "Fermer",
    "CLOSE_SLIP": "Fermer",
    "PLACED_BETS": "Placé",
    "SETTLED_BETS": "Réglé",
    "SLIP": "Coupon",
    "OPEN_BETS": "Ouvert",
    "CLEAR_SELECTIONS": "Retirer sélections",
    "ADD_TO_BET_SLIP": "Ajouter au coupon",
    "NO_BETS": "Aucun pari",
    "COMBINATION_TRICAST": "Combination Tricast",
    "COMBINATION_FORECAST": "Combination Forecast",
    "TOTAL_STAKE": "Mise totale",
    "TOTAL_POTENTIAL_RETURNS": "Total de gains potentiels",
    "N_A": "N/A",
    "PLACE_BETS": "Parier",
    "REMOVE_ALL": "Tout retirer",
    "POT_RETURNS": "Gains pot.",
    "RETURNED": "Rendu",
    "REFUNDED": "Remboursé",
    "OK": "OK",
    "WIN_INITIAL": "V",
    "DRAW_INITIAL": "N",
    "LOSE_INITIAL": "D",
    "SETTINGS": "Paramètres",
    "LANGUAGE": "Langue",
    "LAYOUT": "Layout",
    "ODDS": "Cotes",
    "EN_GB": "English UK",
    "DECIMAL": "Décimal",
    "FRACTIONAL": "Fraction",
    "AMERICAN": "Américain",
    "SIMPLIFIED_DESKTOP": "This is The main class for the desktop simplified UI",
    "SIMPLIFIED_MOBILE": "This is The main class for the mobile simplified UI",
    "SHOW_VIDEO": "Show Video",
    "ALERT_NOTIFICATION": "Alerte",
    "WARNING_NOTIFICATION": "Attention",
    "WARNING_NOTIFICATION_REALITY_CHECK": "Warning",
    "INFO_NOTIFICATION": "INFORMATION",
    "SUCCESS_NOTIFICATION": "Succès",
    "SELECTION_REMOVAL": "Cette sélection sera supprimée dans ",
    "SECONDS": " secondes",
    "SECOND": " seconde",
    "REMOVE_CLOSED_EVENTS": "Enlever les événements fermés",
    "SET_VIDEO_ON_FUL_SCREEN": "Set Video on Full Screen?",
    "CANCEL": "Annuler",
    "INTERNAL_ERROR": "Erreur interne",
    "OPEN_BETS_WARNING": "Certains ou tous les paris ouverts n'ont pas pu être ajoutés au coupon car ils appartiennent à des événements passés.",
    "-32602": "Un ou plusieurs paris n'ont pas été validé à temps.",
    "OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED": "Le nombre maximum de paris dans le coupon a été atteint. Veuillez supprimer ou placer des paris avant d'en ajouter de nouveaux.",
    "-20000": "Le jeu a été suspendu. Veuillez contacter le service client.",
    "-20001": "La session a expiré.",
    "-20002": "Joueur suspendu",
    "-20003": "Les fonds sont insuffisants pour effectuer cette transaction.",
    "-20004": "La vérification de la réalité a échoué.",
    "-10000": "Opération de portefeuille temporairement bloquée.",
    "-10001": "Limite de mise dépassée.",
    "-1000": "Le match a été suspendu. Veuillez contacter le service client.",
    "-999": "Session expirée.",
    "-998": "Joueur suspendu",
    "-997": "Les fonds sont insuffisants pour effectuer cette transaction.",
    "-996": "La vérification de la réalité a échoué.",
    "-995": "Opération de portefeuille temporairement bloquée.",
    "-994": "Limite de mise dépassée.",
    "-980": "Limite de perte dépassée.",
    "-979": "Aucune limite fixée.",
    "-978": "Les fonds sont insuffisants pour effectuer cette transaction.",
    "-977": "La vérification a échoué.",
    "-976": "Opération de portefeuille temporairement bloquée.",
    "-975": "Limite de mise dépassée.",
    "-974": "Limite de perte dépassée.",
    "-973": "Aucune limite fixée.",
    "-972": "Erreur de jeu responsable.",
    "-971": "Échec de l'opération du portefeuille.",
    "-970": "Transaction de portefeuille rejetée.",
    "-969": "Erreur de communication du portefeuille.",
    "-968": "Erreur de transaction du portefeuille.",
    "-967": "Échec de l'authentification.",
    "-966": "Seuil de gain élevé dépassé.",
    "-965": "Paramètres non valides transmis.",
    "BET_STAKE_OUT_OF_LIMITS_MESSAGE": "Un ou plusieurs paris placés ne sont pas valides. Mise minimale : {0}, mise maximale : {1}. Veuillez corriger cela avant de placer vos paris.",
    "LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE": 'Stake limits on {0} are Min {1} & Max {2}',
    "BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE": "Les gains potentiels d'un ou de plusieurs paris dépassent le paiement maximum de {0} . Veuillez corriger cela avant de placer vos paris.",
    "BET_NON_DIVISIBLE_MESSAGE": "Vous ne pouvez pas placer plusieurs paris simples",
    "SINGLE_BET_COMMIT_MESSAGE": "Vous ne pouvez pas placer plusieurs paris simples",
    "REALITY_CHECK_WARNING_MESSAGE_LINE_1": "Le(s) pari(s) que vous placez sont supérieurs à {0}.",
    "MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1": 'The bet(s) you are placing are under {0}',
    "REALITY_CHECK_WARNING_MESSAGE_LINE_2": "Est-ce correct ?",
    "REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING": "Le montant maximum de {0} a été misé. Veuillez sélectionner un autre événement",

    //SIMPLIFIED UI
    "TOTAL_BETS": "PARI TOTAL",
    "PLACE_YOUR_BETS": "Placez votre pari",
    "RACE_START": "Départ de la course",
    "RACE_START_TIME": "Heure de départ",
    "BET_SUMMARY": "Résumé du pari",
    "NO_BETS_RESUME": "Aucun pari n'a été effectué pour l'événement en cours",
    "LIVE": "EN DIRECT",
    "RACERS": "Sélection",
    "SELECTION": "Sélection",
    "DATE_LOCATION": "Événement",
    "STAKE": "Mise",
    "BET_TYPE_STAKE": "Type de pari / Mise",
    "POTENTIAL_RETURNS": "Gains Pot. ",
    "BET_HISTORY": "Historique des paris",
    "BET_HISTORY_LABEL": "Pour plus d'historique, cliquez sur le bouton Historique des paris",
    "FILTER_WINS": "Filtrer les paris gagnés",
    "NEXT_RACE": "Prochaine course",
    "WIN": "Gagner",
    "PLACE": "Placer",
    "SHOW": "Événement",
    "EXACTA": "Couplé ordre",
    "TRIFECTA": "Trio ordre",
    "NO_WIN": "PAS GAGNÉ",
    "WON": "GAGNÉ",
    "LOST": "PERDU",
    "CURRENT_RACE": "Course en cours",
    "BOX": "BOÎTE",
    "TO": "à",
    "PAYS": "paie",
    "TRIFECTA_BOX": "Terminez vos paris",
    "EXACTA_BOX": "Sélectionnez votre pari ci-dessous",
    "FINISH_YOUR_BETS": "Finalisez vos paris",
    "SELECT_YOUR_BET_BELOW": "Sélectionnez votre pari ci-dessous",
    "BET": "pari",
    "REMOVED": "supprimé",
    "RESULT": "Résultat",
    "GOALS": "Buts",
    "NO_MORE_BETS": "Pas d'autres paris",
    "EVENT_LIVE_MSG_LINE_1": "Événement actuel en direct",
    "EVENT_LIVE_MSG_LINE_2": "Sélectionner à partir du prochain",
    "EVENT_LIVE_MSG_LINE_3": "Événement au-dessus",
    "NO_FUTURE_EVENTS": "Pas de prochains événements",
    "AUTHENTICATION_REQUIRED": "Veuillez vous connecter pour continuer",
    "GAME_DISABLED": "Match annulé",
    "GAME_DISABLED_MESSAGE": "Veuillez contacter le service client.",
    "VOIDED": "ANNULÉ",
    "HELP": "Aide",
    "LAST_RESULTS": "Dernier résultats",
    "NO_LAST_RESULTS": "montrer",
    "PREVIOUS_RESULTS": "Previous Results",
    "OFFENSE_PREVIOUS_RESULTS": "Offence Previous Results",
    "DEFENSE_PREVIOUS_RESULTS": "Defence Previous Results",
    "NO_LUCK": "NO LUCK",
    "THIS_TIME": "THIS TIME",
    "LOOK_FOR_THE_NEXT": "Cherchez le",
    "SCHEDULED_EVENT": "prochain événement",
    "LOOK_FOR_THE": "Cherchez le",
    "NEXT_SCHEDULED": "prochain",
    "EVENT": "événement",
    "RETURNS": "Revenir en arrière",
    "NEXT": "Suivant",
    "FUTURE": "Prochain ",
    "PLAYING": "Jouer",

    "ON": "sur",
    "MB_RACE_ON": "on",
    "MB_RACE_WIN": "gagner",
    "MB_RACE_PLACE": "placer",
    "MB_RACE_SHOW": "afficher",
    "MB_RACE_TRIFECTA_BOX": "combination tricast",
    "MB_RACE_EXACTA_BOX": "combination forecast",
    "MB_RACE_EXACTA": "forecast",
    "MB_RACE_TRIFECTA": "tricast",
    "MB_FOOTBALL_ON": "on",
    "ADVERTISING_SPACE": "ADVERTISING SPACE",
    "CLEAR_LAST": "Effacer le dernier",
    "CLEAR_ALL": "Tout effacer",
    "ACTIVE_BETS": "Paris actifs",
    "ONLY_SHOW_WINS": "Montrer seulement les gains",
    "MORE": "Plus",
    "BETS": "Paris",
    "LOADING": "Chargement",
    "BET_SELECTION_MESSAGE": "Faites votre sélection en cliquant sur les cotes.",
    "SIMPLE": "simple",
    "EXOTIC": "exotic",
    "UNDO": "undo",
    "CLEAR": "effacer",
    "HISTORY": "historique",
    "MARKETS": "Marchés",
    "MAIN": "Principal",
    "VS": "vs",
    "AT": "@",
    "SCORE": "score",
    "DEFENDS": "(Defends) at",
    "ATTACKS": "(Attacks) at",
    "DETAILS": "Détails",
    "NO_GOALS": "Aucun but",
    "MAX_WINNINGS_REACHED": "Gains max. atteints",
    "MAX_WINNINGS_REACHED_TEXT": "Le pari actuel dépassera le paiement maximum de {0}. La valeur de la mise maximum autorisée pour ce pari est de {1}.",
    "NO_CONNECTION_TITLE": "Connexion perdue",
    "NO_CONNECTION_TITLE_TEXT": "Connexion perdue avec le serveur, assurez-vous d'avoir une connexion réseau stable et actualisez la page. Si le problème persiste, contactez le support.",
    "PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT": "Connexion fermée, l'utilisateur s'est connecté deux fois.",
    "BET_CONFIRMED_TEXT": "none",
    "TAX_NOTIFICATION_TEXT": "none",
    "THE MANOR GROUND": "Berners Stadium",
    "METRO STADIUM": "Metro Stadium",
    "HorsesSprints": "Wetmore Sprints",
    "Showell Park": "Showell Park",
    "2FurlongHorses": "Wetmore Sprints",
    "Sandringham Flats": "Sandringham Flats",
    "Princess Parkway": "Princess Parkway",
    "Virtual Arena": "Virtual Arena",
    "Inspired Arena": "Inspired Arena",
    "HorsesJumps": "Inspired Downs",
    "DogFlat": "Barking Green",
    "Dogs2": "Barking Green",
    "Victoria Park": "Victoria Park",
    "Jennison Stadium": "Jennison Stadium",
    "Circuit": "Circuit",
    "Speedway Park": "Inspired Raceway",
    "Auto Raceway": "Auto Raceway",
    "NO_CONNECTION_TO_VIRGO": "La connexion a été perdue",
    "NO_CONNECTION_TO_VIRGO_TEXT": "Veuillez rafraîchir la page et vous reconnecter",
    "BROWSER_NOT_SUPPORTED_DETAILS": "Votre navigateur actuel n'est pas pris en charge. Veuillez utiliser l'un des navigateurs suivants : Chrome, Firefox ou Safari.",
    "BROWSER_NOT_SUPPORTED": "Navigateur non pris en charge",
    "DOWNLOAD_CHROME": "Télécharger Chrome",
    "DOWNLOAD_FIREFOX": "Télécharger Firefox",
    "v": "V",
    "1": "1",
    "x": "X",
    "2": "2",
    "at": "@",
    "+10.5": "+10,5",
    "+15.5": "+15,5",
    "+5.5": "+5,5",
    "-10.5": "-10,5",
    "-15.5": "-15,5",
    "-5.5": "-5,5",
    "Over 219.5": "Plus 219.5",
    "Under 219.5": "Moins 219.5",
    "Over 214.5": "Plus 214.5",
    "Under 214.5": "Moins 214.5",
    "Over 209.5": "Plus 209.5",
    "Under 209.5": "Moins 209.5",
    "Over 144.5": "Plus 144.5",
    "Under 144.5": "Moins 144.5",
    "Over 149.5": "Plus 149.5",
    "Under 149.5": "Moins 149.5",
    "Over 154.5": "Plus 154.5",
    "Under 154.5": "Moins 154.5",
    "Over 159.5": "Plus 159.5",
    "Under 159.5": "Moins 159.5",
    "Over 164.5": "Plus 164.5",
    "Under 164.5": "Moins 164.5",
    "Marble Racing": "Course de billes",
    "Rolling Downs": "Rolling Downs",
    "FINISHING_ORDER": "Ordre d'arrivée",
    "FORECAST_MARBLE": "Top 2 ",
    "TRICAST_MARBLE": "Top 3 ",
    "REVERSE_FORECAST_MARBLE": "Top 2 peu importe l'ordre",
    "REVERSE_TRICAST_MARBLE": "Top 3 peu importe l'ordre",
    "TO_WIN_MARBLE": "Gagner",
    "PLACE_MARBLE": "Placer",
    "SHOW_MARBLE": "Événement",
    "MARBLE": "Bille",
    "Rumble Turns": "Rumble Turns",
    "Maple Downs": "Maple Downs",
    "BALANCE": "Solde",
    "DATE_FORMAT": "DD/MM/YYYY HH:mm",
    "WINS_THE_GAME": "Pariez les deux",
    "Any": "Tout",
    "BET_BOTH": "Parier les deux",
    "Matchday_English": "Journée",
    "Matchday_Turkish": "Journée",
    "Matchday_Greek": "Journée",
    "Matchday_English_Matchday_English": "Journée",
    "Matchday_Turkish_Matchday_Turkish": "Journée",
    "Matchday_Greek_Matchday_Greek": "Journée",
    "betSlip_Matchday_English": "Journée anglaise",
    "betSlip_Matchday_Turkish": "Journée Turkish",
    "betSlip_Matchday_Greek": "Journée Greek",
    "betSlip_Soccer": "Football",
    "betSlip_Horses": "Courses hippiques",
    "betSlip_Basketball": "Basketball",
    "betSlip_Dogs": "Chiens",
    "betSlip_Motor Racing": "Courses de moto",
    "betSlip_US Football": "Football américain",
    "betSlip_Marble Racing": "Course de billes",
    "POS": "pos",
    "TEAM": "équipe",
    "P": "p",
    "W": "w",
    "D": "d",
    "L": "l",
    "F": "f",
    "A": "a",
    "PTS": "pts",
    "LEAGUE TABLE": "classement",
    "TREND": "tendance",
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",
//Soccer3 Greek Teams
    "Dikefalos Vora": "ΔΙΚ",
    "Erithrolefkoi": "ΘΡΥ",
    "Enosi": "ΕΝΩ",
    "Peristeri": "ΠΕΡ",
    "Prasinoi": "ΠΡΑ",
    "Kitrinoi Vora": "ΚΙΤ",
    "Nea Smirni": "ΣΜΥ",
    "Xanthi": "ΞΑΝ",
    "Tripoli": "ΤΡΙ",
    "Agrinio": "ΑΓΡ",
    "Larisa": "ΛΑΡ",
    "Lamia": "ΛΑΜ",
    "Ioannina": "ΙΩΑ",
    "Iraklio": "ΗΡΑ",
    "A.O. Rizoupolis": "ΡΙΖ",
    "Volos": "ΒΟΛ",
    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    "UNDER_OVER_MATCHDAY": "Plus/Moins",
    "UNDER_OVER_05_SHORT": "0.5",
    "UNDER_OVER_15_SHORT": "1.5",
    "UNDER_OVER_25_SHORT": "2.5",
    "UNDER_OVER_35_SHORT": "3.5",
    "UNDER_SHORT": "M",
    "OVER_SHORT": "P",
    "FULL TIME": "Temps complet",
    "FT": "FT",
    "System": "Système",
    "x1": "(x1)",
    "Multiplier": "Répéter le pari",
    "Main markets": "Marchés principaux",
    "4RANDOM": "4 RANDOM",
    "6RANDOM": "6 RANDOM",
    "8RANDOM": "8 RANDOM",
    "8FAVS": "8 FAVS",
    "QUICK_SELECT": "SÉLECTION RAPIDE",
    "UNDER": "Moins",
    "OVER": "Plus",
    "UNDER_OVER_2_5": "Plus/Moins 2.5",
    "UNDER_OVER_3_5": "Plus/Moins 3.5",
    "MATCH_RESULT": "RÉSULTAT DU MATCH",
    "YES": "OUI",
    "NO": "NON",
    "REALITY_CHECK_WARNING_YES": "Oui",
    "REALITY_CHECK_WARNING_NO": "Non",
    "ACCUMULATOR": "Accumulateur",
    "+1G": "+1G",
    "Single": "Simple ",
    "Doubles": "Double",
    "Trebles": "Triple",
    "Four Folds": "4 sélections",
    "Five Folds": "5 sélections",
    "Six Folds": "6 sélections",
    "Seven Folds": "7 sélections",
    "Eight Folds": "8 sélections",
    "MD": "J{0}",
    "MATCH": "MATCH",
    "INVALID_ACCA": "Lorsque les sélections apparaissent en surbrillance, vos sélections multiples sont restreintes",
    "INVALID_ODDS": "La valeur de cote est trop élevée. Veuillez modifier vos sélections",
    "INVALID_ACCA_MORETHAN_8": "Les paris multiples sur un même match ne peuvent pas contenir plus de 8 sélections",
    "ACCUMULATOR_BOOST": "Boost accumulateur",
    "Bonus_Info": " {0} % de bonus",
    "+": "+",
    "Bonus_Value": "{0} Bonus inclus",
    "ACCUMULATOR_INFO": "Si votre pari cumulé est réussi, un bonus de {0} % - {1} % est ajouté à vos gains. Le montant du bonus dépend du nombre de sélections.",
    "BET_TYPE": "Type de pari",
    "BOOST": "Boost",
    "BOOST_PERCENTAGE": "{0} %",
    "BOOST_BONUS_START": "{0} ou plusieurs sélections cumulées recevront un bonus",
    "BOOST_BONUS_UPGRADE": "Ajoutez une autre sélection cumulée pour recevoir un bonus supplémentaire",
    "BOOST_BONUS_MAX": "Vous avez le bonus accumulateur maximum",
    "Marbles_Euro_1": "Belgium",
    "Marbles_Euro_2": "Croatia",
    "Marbles_Euro_3": "Denmark",
    "Marbles_Euro_4": "England",
    "Marbles_Euro_5": "France",
    "Marbles_Euro_6": "Germany",
    "Marbles_Euro_7": "Italy",
    "Marbles_Euro_8": "Netherlands",
    "Marbles_Euro_9": "Portugal",
    "Marbles_Euro_10": "Spain",
    "Short_Over": "Plus {0}",
    "Short_Under": "Moins {0}",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Please register or log in to place a bet",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": " ",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Dismiss",
    "DEMOPLAY_NOTIFICATION_OK": "OK",
    "Matchday_Moroccan": "Journée",
    "Matchday_Moroccan_Matchday_Moroccan": "Journée",
    "betSlip_Matchday_Moroccan": "Journée",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    "QUICK_FILL": "Quick Fill",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Journée",
    "Matchday_Belgium_Matchday_Belgium": "Journée",
    "betSlip_Matchday_Belgium": "Journée België",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading" :"A GIFT FOR YOU",
    "Gift_for_You_Content": "Congratulations! You have promotional offers to redeem.",
    "View_Offers" : "VIEW OFFERS",
    "Do_Not_Show_MSG": "DO NOT SHOW AGAIN",
    "MY_OFFERS" : 'MY OFFERS',
    "SELECT_OFFER" : 'SELECT YOUR OFFER',
    "NO_OFFER" : 'THERE ARE NO ACTIVE OFFERS',
    "CHOOSE_BET": 'CHOOSE BET',
    "Opt_In": 'OPT IN',
    "Key_Terms_Heading" :"KEY TERMS",
    "No_Thanks" : "NO THANKS",
    "PROMO_BET": 'PROMO BET',
    "Time_To_Bet": "TIME TO BET",
    "OPTED_IN_MSG": "THANKS, YOU HAVE OPTED IN",
    "EXP": "Exp.",
    "SELECT": "Select",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "This demo site does not currently offer any promos. Please log in/register to access current offers. !",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Cricket",
    "Cricket_International": "International",
    "betSlip_Cricket": "Cricket",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Tie",
    //cricket markets
     "MATCH_WINNER":"Vainqueur du match",
     "TOTAL_SIXES_IN_MATCH":"Total de 6 du match",
     "TOTAL_SIXES_IN_MATCH_SHORT": "Moins 1.5",
     "TOTAL_FOUR_IN_MATCH":"Total de 4 du match",
     "TOTAL_BOUNDARIES_IN_MATCH":"Total de limites du match",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Total de points",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} Points marqués au premier lancer",
     "FIRST_TEAM_WICKET_LOST":"{0} Guichet perdu",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} Première méthode de type d'élimination",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Points marqués avec la première balle over/under",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Points marqués avec la première balle over/under",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Points marqués avec la première balle over/under",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Points marqués avec la première balle over/under",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Points marqués avec la première balle over/under",
     "Caught" : "Attrapé",
     "Bowled":"Lancé",
     "LBW":"JDG",
     "No Wicket":"Pas de guichet",
     "OverZeroPointFive": "Over 0.5",
     "UnderZeroPointFive": "Under 0.5",
     "OverOnePointFive": "Over 1.5",
     "UnderOnePointFive": "Under 1.5",
     "OverTwoPointFive": "Over 2.5",
     "UnderTwoPointFive": "Under 2.5",
     "OverThreePointFive": "Over 3.5",
     "UnderThreePointFive": "Under 3.5",
     "Yes": "Yes",
     "No":"No",
     "FINAL_SCORE":"Final Score",
     OVER_145: 'Over 14.5',
     UNDER_145: 'Under 14.5',
     DRAW_Cricket: "DRAW",
      //TENNIS
    TOTAL_POINTS:"Score total",
    HANDICAP_TENNIS: "Handicap",
    Scotland :"Scotland",
    USA: "USA",
    Tennis_International: "International",
    betSlip_Tennis: "Tennis",
    "Win By 2 or 3": "Victoire par 3 points ou moins",
    "Win By 4 or 5": "Victoire par 4 ou 5 points",
    "Win By 6 or 7": "Victoire par 6 ou 7 points",
    "Tennis": "Tennis",
   //baseball
    WINNER : "VAINQUEUR",
    TOTAL_HOME_RUNS_UNDER_OVER: "TOTAL COUPS DE CIRCUIT +/-",
    TOTAL_HOME_RUNS:  "TOTAL EXACT COUPS DE CIRCUIT",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"VAINQUEUR ET TOTAL COUPS DE CIRCUIT +/- 5,5",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Vainqueur et total CC +/- 5,5",
    BATTER1_HOME_RUNS: "{0} COUPS DE CIRCUIT",
    BATTER2_HOME_RUNS: "{1} COUPS DE CIRCUIT",
    Baseball_HR_ShootOut_Legends: "Home Runs Shootout-Legends",
    Baseball_HR_ShootOut_Legends_SHORT: "Tir de CC",
    "Baseball": "Baseball",
    "betSlip_Baseball": "Baseball",
    "Player 1 AND OVER_5_5":"{0} et + de 5.5",
    "Player 2 AND OVER_5_5":"{0} et + de 5.5",
    "Player 1 AND UNDER_5_5":"{0} et - de 5.5",
    "Player 2 AND UNDER_5_5":"{0} et - de 5.5",
    "Draw AND OVER_5_5":"Match nul et + de 5,5",
    "Draw AND UNDER_5_5":"Match nul et - de 5,5",
    "HOME RUNS":"{0} COUPS DE CIRCUIT",
    "Next Fixtures":"Next Fixtures",
    "MATCH_IN_PROGRESS": "Match In Progress",
    "Matchday_Light_English": "Matchday Light",
    "Matchday_Light_English_Matchday_Light_English": "English League",
    "betSlip_Matchday_Light_English": "Matchday Light",
     //NFL
    'Cardinals' : 'Cardinals',
    'Falcons' : 'Falcons',
    'Ravens' : 'Ravens',
    'Bills' : 'Bills',
    'Panthers' : 'Panthers',
    'Bears' : 'Bears',
    'Bengals' : 'Bengals',
    'Browns' : 'Browns',
    'Cowboys' : 'Cowboys',
    'Broncos' : 'Broncos',
    'Lions' : 'Lions',
    'Packers' : 'Packers',
    'Texans' : 'Texans',
    'Colts' : 'Colts',
    'Jaguars' : 'Jaguars',
    'Chiefs' : 'Chiefs',
    'Raiders' : 'Raiders',
    'Chargers' : 'Chargers',
    'Rams' : 'Rams',
    'Dolphins' : 'Dolphins',
    'Vikings' : 'Vikings',
    'Patriots' : 'Patriots',
    'Saints' : 'Saints',
    'Giants' : 'Giants',
    'Jets' : 'Jets',
    'Eagles' : 'Eagles',
    'Steelers' : 'Steelers',
    '49ers' : '49ers',
    'Seahawks' : 'Seahawks',
    'Buccaneers' : 'Buccaneers',
    'Titans' : 'Titans',
    'Commanders' : 'Commanders',
    'NEW' : 'New',
    //Soccer_Soccer3_Turkish_League team names and game name
    "Soccer_Soccer3_Turkish_League": "Turkish League",
    "Basaksehir": "BAS",
    "Trabzon": "TRZ",
    "Besiktas": "BKS",
    "Sivas": "SIV",
    "Alanya": "ALA",
    "Galata": "GLS",
    "Fenerbahce": "FRB",
    "Gazientep": "GAZ",
    "Antalya": "ANT",
    "Kasimpasa": "KAS",
    "Goztepe": "GOZ",
    "Gencler": "ESK",
    "Konya": "BUR",
    "Rize": "RIZ",
    "Malatya": "MAL",
    "Kayseri": "KAY",

    //NBA 
  "Basketball_NBA": "NBA",
  "Atlanta Hawks": "Atlanta Hawks",
  "Boston Celtics": "Boston Celtics",
  "Brooklyn Nets": "Brooklyn Nets",
  "Charlotte Hornets": "Charlotte Hornets",
  "Chicago Bulls": "Chicago Bulls",
  "Cleveland Cavaliers": "Cleveland Cavaliers",
  "Dallas Mavericks": "Dallas Mavericks",
  "Denver Nuggets": "Denver Nuggets",
  "Detroit Pistons": "Detroit Pistons",
  "Golden State Warriors": "Golden State Warriors",
  "Houston Rockets": "Houston Rockets",
  "Indiana Pacers": "Indiana Pacers",
  "Los Angeles Clippers": "Los Angeles Clippers",
  "Los Angeles Lakers": "Los Angeles Lakers",
  "Memphis Grizzlies": "Memphis Grizzlies",
  "Miami Heat": "Miami Heat",
  "Milwaukee Bucks": "Milwaukee Bucks",
  "Minnesota Timberwolves": "Minnesota Timberwolves",
  "New Orleans Pelicans": "New Orleans Pelicans",
  "New York Knicks": "New York Knicks",
  "Oklahoma City Thunder": "Oklahoma City Thunder",
  "Orlando Magic": "Orlando Magic",
  "Philadelphia 76ers": "Philadelphia 76ers",
  "Phoenix Suns": "Phoenix Suns",
  "Portland Trail Blazers": "Portland Trail Blazers",
  "Sacramento Kings": "Sacramento Kings",
  "San Antonio Spurs": "San Antonio Spurs",
  "Toronto Raptors": "Toronto Raptors",
  "Utah Jazz": "Utah Jazz",
  "Washington Wizards": "Washington Wizards",
  "TOTALPOINTS": "TOTAL POINTS"
}


// WEBPACK FOOTER //
// ./src/localization/fr_BE.js